(function ($) {
    class W4D_Cart {
        constructor() {
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.$body = $('body');
            this.woocommerce = $('.woo-wrapper');
            this.cart = $('.cart');
            this.removeCartItem = '.js-remove-cart-item';
            this.cartCollaterals = $('.cart-collaterals');
            this.progressBar = $('.progress-bar');
            this.$addToCartButton = '.w4d_add_to_cart_button.single_add_to_cart_button';
            this.$sendInquiryButton = $('.w4d-send-inquiry');
            this.emptyCart = '[data-js-empty-cart]';
            this.$stockStatusElements = {
                instock: $(".shop-sidebar__info .instock"),
                outofstock: $(".shop-sidebar__info .availability.availability--query"),
                onbackorder: $(".shop-sidebar__info .availability.availability--backorder"),
            };
        }

        bindEvents() {
            this.$body.on('click', '.w4d_add_to_cart_button', (e) => this.handleAddToCart(e));
            $(document).on('click', this.removeCartItem, (e) => this.handleRemoveCartItem($(e.currentTarget)));
            $(document).on('change', '.variations select', (e) => this.handleVariationChange(e));
            $(document).on('click', this.emptyCart, (e) => this.handleRemoveCartAll($(e.currentTarget)));;

            let selectCount = $('.variations select').length;
            let selectedOptionsCount = $('.variations select option:selected[value!=""]').length;
            if(selectCount === selectedOptionsCount){
                this.handleVariationChange();
            }
        }
        handleRemoveCartAll($item) {
            let $cartContainer = $('.woocommerce-cart-form').parent().parent().parent();

            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.ajax_url,
                data: {
                    action: 'w4d_empty_cart',
                    nonce: w4d_frontend_ajax.nonce
                },
                beforeSend: () => {
                    this.cart.addClass('cart--loading');
                    this.cartCollaterals.addClass('cart-collaterals--loading');
                },
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Košarica ispraznjena!');
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        this.cartCollaterals.html(response.data.cart_summary);
                        if (response.data.cart_empty_html) {
                            this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
                        }
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: (xhr, status, error) => {
                    console.error("Greška u pozivu:", error);
                }
            });
        }

        handleRemoveCartItem($item) {
            let productId = $item.data('product-id');
            let variationId = $item.data('variation-id');
            let cartItemKey = $item.data('cart-item-key');
            let $cartRow = $item.closest('.cart__item');
            let productName = $cartRow.find('.product-name a').text();
            let $cartContainer = $('.woocommerce-cart-form').parent().parent().parent();

            let ajaxData = {
                action: 'w4d_add_to_cart',
                cart_item_key: cartItemKey,
                product_id: productId,
                variation_id: variationId,
                quantity: 0,
                update_cart: true,
                return_cart_data: true,
                nonce: w4d_frontend_ajax.nonce
            };

            $cartRow.addClass('removing');

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    this.cart.addClass('cart--loading');
                    this.cartCollaterals.addClass('cart-collaterals--loading');
                    $cartRow.addClass('cart__item--removing');
                },
                success: (response) => {
                    if (response.success) {
                        $cartRow.slideUp(300, function() {
                            $(this).remove();
                        });
                        W4D_FrontendHelper.showNotice('success', `${productName} uklonjen`);
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        this.cartCollaterals.html(response.data.cart_summary);

                        if (response.data.cart_empty_html) {
                            this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
                        }

                        W4D_ProgressBar.updateProgressAfterCartChange(response.data.cart_total);
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: (xhr, status, error) => {

                }
            });
        }

        handleCartEmptyState(html, element) {
            element.empty().html(html);
            $('.woo-wrapper__sidebar').remove();
        }

        handleUpdateCartOnCartPage(input) {
            let $cartRow = input.closest('.cart__item');
            const inputValue = parseFloat(input.attr('value'));
            const $step = parseFloat(input.attr('step'));
            const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
            const remainder = inputValue % $step;
            let roundedValue;

            if (remainder > 0) {
                // Ako vrijednost nije višekratnik koraka, zaokruži na sljedeći višekratnik
                roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(inputValue / $step) * $step, $step_decimal_places);
            } else {
                // Vrijednost je već višekratnik koraka, zadrži je kakva jest
                roundedValue = inputValue;
            }

            const displayValue = String(roundedValue).replace('.', ',');

            input.val(displayValue)
                .attr('value', roundedValue)
                .attr('data-quantity', roundedValue)
                .data('quantity', roundedValue)
                .trigger('change');

            let ajaxData = {
                action: 'w4d_add_to_cart',
                update_cart: true,
                return_cart_data: true,
                product_id: input.data('product-id'),
                variation_id: input.data('variation-id'),
                quantity: roundedValue,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    this.cart.addClass('cart--loading');
                    this.cartCollaterals.addClass('cart-collaterals--loading');
                    $cartRow.addClass('cart__item--removing');
                },
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Košarica je uspješno ažurirana');
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        const cartItemRow = input.closest('tr.woocommerce-cart-form__cart-item');
                        const totalElement = cartItemRow.find('.product-subtotal');

                        if (totalElement.length) {
                            totalElement.html(response.data.item_total);
                        }

                        if (response.data.cart_summary) {
                            $('.cart-collaterals').html(response.data.cart_summary);
                        }

                        W4D_ProgressBar.updateProgressAfterCartChange(response.data.cart_total);

                    } else {
                        W4D_FrontendHelper.showNotice('error', 'Greška: ' + response.data.message);
                        console.error(response.data.message);
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: () => this.handleAddToCartError()
            });
        }

        handleUpdateCart($element) {
            let location = $element.data('location');
            let $new_qty;
            let product_id = $element.data('product-id');

            if (location === 'product-flyout') {
                $new_qty = parseFloat($element.data('quantity'));
            }

            if (location === 'table-view') {
                $new_qty = parseFloat($element.attr('value'));
            }

            let data = {
                action: 'w4d_add_to_cart',
                update_cart: true,
                return_cart_data: false,
                product_id: product_id,
                quantity: $new_qty,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: data,
                beforeSend: () => {
                    if ($element.hasClass('w4d_update_cart_button')) {
                        $element.prop('disabled', true);
                    }
                    this.setButtonLoading($element, true);
                },
                success: (response) => {
                    if (response.success) {
                        if ($element.hasClass('w4d_update_cart_button')) {
                            this.handleProductFlyoutUpdateCartSuccess(response, $element, $new_qty);
                        } else {
                            this.handleUpdateCartSuccess(response, $element);
                        }
                        W4D_FrontendHelper.showNotice('success', 'Košarica uspješno ažurirana');
                    } else {
                        let cartIcon = $element.parent().find('.product-quantity__cart');
                        cartIcon.addClass('product-quantity__cart--error');
                    }
                    let input = $element.parent().find('.product-quantity__number:first');
                    input.attr('data-quantity', $new_qty).data('quantity', $new_qty).trigger('change');
                },
                complete: () => {
                    $element.toggleClass('loading');
                },
                error: () => this.handleAddToCartError()
            });
        }

        handleProductFlyoutUpdateCartSuccess(response, button, quantity) {
            W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
            // Update sidebar input
            $('.product-flyout__content .product-quantity__number')
                .data('quantity', quantity)
                .attr('data-quantity', quantity);

            // Update product row input
            const productId = button.data('product-id');
            $(`.product-table__row[data-product-id="${productId}"] .product-quantity__number`)
                .data('quantity', quantity)
                .attr('data-quantity', quantity)
                .val(quantity)
                .attr('value', quantity);

            // Update total column with response.item_total
            $(`.product-table__row[data-product-id="${productId}"] .product-table__data--item-total`)
                .html(response.data.item_total)

            button.prop('disabled', true);
        }

        handleUpdateCartSuccess(response, input) {
            const totalElement = input.closest('.product-table__row').find('.product-table__data--item-total');
            totalElement.removeClass('animate-total');

            W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

            const $parent = input.parent();
            $parent.addClass('product-quantity--added-to-cart');

            totalElement
                .html(response.data.item_total)
                .addClass('animate-total');

            setTimeout(() => {
                totalElement.removeClass('animate-total');
            }, 500);

            setTimeout(() => {
                $parent
                    .removeClass('product-quantity--added-to-cart')
                    .removeClass('product-quantity--changed');
            }, 2300);
        }

        handleAddToCart(e) {
            e.preventDefault();
            const $button = $(e.currentTarget);
            let quantity;

            if ($button.hasClass('single_add_to_cart_button')) {
               quantity = parseFloat($button.parent().find('.product-quantity__number').attr('value').replace(',', '.'))
            } else {
                quantity = $button.data('quantity');
            }

            const data = {
                action: 'w4d_add_to_cart',
                product_id: $button.data('product-id'),
                quantity: quantity,
                variation_id: $button.data('variation-id') || 0,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: data,
                beforeSend: () => this.setButtonLoading($button, true),
                success: (response) => this.handleAddToCartSuccess(response, $button),
                complete: () => this.setButtonLoading($button, false),
                error: () => this.handleAddToCartError()
            });
        }

        setupLoadingClickPrevention() {
            $(this.$addToCartButton).on('click', (e) => {
                if ($(e.currentTarget).hasClass('loading')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });
        }

        setButtonLoading($button, isLoading) {
            $button.toggleClass('loading', isLoading);
            $button.prop('disabled', isLoading);
        }

        handleAddToCartSuccess(response, button) {
            if (response.success) {
                W4D_FrontendHelper.showNotice('success', 'Artikl je dodan u košaricu.');
                W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

                const productId = button.data('product_id');
                const totalElement = $(`.product-table__row[data-product-id="${productId}"] .product-table__data--item-total`);
                if (totalElement.length) {
                    totalElement.html(response.data.item_total);
                }

            } else {
                W4D_FrontendHelper.showNotice('error', 'Greška: ' + response.data.message);
                console.error(response.data.message);
            }
        }

        handleAddToCartError() {
            W4D_FrontendHelper.showNotice('error', 'Došlo je do greške prilikom dodavanja artikla u košaricu.');
        }

        // >----------------------------------------- VARIABLE PRODUCT METHODS -----------------------------------------<

        handleVariationChange() {
            if($('.variations_container').length === 0) {
                return;
            }
            this.setupLoadingClickPrevention();

            this.$variationSelects = $('.variations select');
            this.$summaryDescription = $('#summary-description .accordion__content');
            this.$variationPrice = $('.single_variation_wrap .woocommerce-variation-price');
            this.$samoPregled_showPrice = this.$variationPrice.attr('data-js-show-price');
            this.$ident = $('.shop-sidebar__info span.ident');

            const selectedAttributes = this.getSelectedAttributes();
            const matchingVariation = this.findMatchingVariation(selectedAttributes);

            this.updateSelectOptions();
            if (matchingVariation) {
                this.updateVariationData(matchingVariation);
            } else {
                this.resetVariationData();
            }
        }

        getSelectedAttributes() {
            let attributes = {};
            this.$variationSelects.each(function () {
                let attributeName = $(this).data('attribute_name');
                let attributeValue = $(this).val();
                if (attributeValue.length > 0) {
                    attributes[attributeName] = attributeValue;
                }
            });
            return attributes;
        }

        findMatchingVariation(attributes) {
            const productVariations = $('.variations_container').data('product_variations');
            return productVariations.find(variation =>
                Object.entries(variation.attributes).every(([attr_name, attr_value]) =>
                    attributes[attr_name] === attr_value
                )
            );
        }

        findMatchingVariations(selectedAttributes) {
            const productVariations = $('.variations_container').data('product_variations');
            return productVariations.filter((variation) => {
                for (const attr in selectedAttributes) {
                    if (selectedAttributes[attr] && selectedAttributes[attr] !== variation.attributes[attr]) {
                        return false;
                    }
                }
                return true;
            });
        }

        // Determine which values are possible for a given attribute based on other selected attributes
        getPossibleValuesForAttribute(attributeName, selectedAttributes) {
            const matchedVariations = this.findMatchingVariations(selectedAttributes);
            const possibleValues = new Set();

            matchedVariations.forEach((variation) => {
                if (variation.attributes[attributeName]) {
                    possibleValues.add(variation.attributes[attributeName]);
                }
            });

            return possibleValues;
        }

        getSelectedAttributes2() {
            const selectedAttributes = {};
            jQuery(this.$variationSelects).each(function () {
                const attributeName = jQuery(this).data('attribute_name');
                const val = jQuery(this).val();
                if (val !== "") {
                    selectedAttributes[attributeName] = val;
                }
            });
            return selectedAttributes;
        }

        // Update the enabled/disabled state of all select options based on currently selected attributes
        updateSelectOptions() {
            const selectedAttributes = this.getSelectedAttributes2();
            const $selects = jQuery(this.$variationSelects);

            $selects.each((index, select) => {
                const $select = jQuery(select);
                const attributeName = $select.data('attribute_name');

                // Temporarily remove this attribute from the selection
                // so we can figure out possible values without it restricting
                const originalValue = selectedAttributes[attributeName] || "";
                if (originalValue) {
                    delete selectedAttributes[attributeName];
                }

                const possibleValues = this.getPossibleValuesForAttribute(attributeName, selectedAttributes);

                // Re-add original value if it was set
                if (originalValue) {
                    selectedAttributes[attributeName] = originalValue;
                }

                // Enable/disable options based on possible values
                $select.find('option').each(function () {
                    const optionValue = jQuery(this).attr('value');

                    // Never disable the empty option
                    if (optionValue === "") {
                        jQuery(this).prop('disabled', false);
                        return;
                    }

                    if (possibleValues.has(optionValue)) {
                        jQuery(this).prop('disabled', false).show();
                    } else {
                        jQuery(this).prop('disabled', true).show();
                        // If you prefer hiding them:
                        // jQuery(this).hide();
                    }
                });

                // If the currently selected value is no longer valid, reset it
                const currentValue = $select.val();
                if (currentValue && !possibleValues.has(currentValue)) {
                    $select.val("");
                }
            });
        }

        updateVariationData(variation) {
            $(this.$addToCartButton).prop('disabled', false)
                .data('variation-id', variation.variation_id);

            this.$ident.text(variation.ident);
            this.updateStockStatus(variation);
            this.updateDescription(variation);
            this.updatePrice(variation);
            this.updateImage(variation);
            this.updateAttributes(variation);

            let queryString = new URLSearchParams(variation.attributes).toString();
            let newUrl = window.location.pathname + '?' + queryString;
            history.replaceState(null, '', newUrl);
        }

        resetVariationData() {
            history.replaceState(null, '', window.location.pathname);
            $(this.$addToCartButton).prop('disabled', true)
                .removeData('variation-id')
                .attr("aria-hidden", false);
            this.$sendInquiryButton.attr("aria-hidden", true);
            this.$ident.text('-');
            this.$variationPrice.empty();
            $('[data-attr-value]').each(function () {
                $(this).html($(this).attr('data-attr-value'));
            });
            Object.values(this.$stockStatusElements).forEach($el => ($el.attr('default') === undefined) ? $el.hide() : $el.show());
        }

        updateStockStatus(variation) {
            Object.values(this.$stockStatusElements).forEach($el => $el.hide());
            const toShow = this.$stockStatusElements[variation.stock_status];
            if (toShow) {
                toShow.show();
            }
        }

        // Additional helper methods for updating specific parts of the variation
        updateDescription(variation) {
            if (variation.variation_description?.trim()) {
                this.$summaryDescription.empty().append(variation.variation_description);
            } else {
                this.$summaryDescription.html(this.$summaryDescription.attr('data-attr-value'));
            }
        }

        updatePrice(variation) {
           this.$variationPrice.empty();

           if(!this.$samoPregled_showPrice){

                let $stanja = JSON.parse(variation.stanje_skl);

                if(Array.isArray($stanja)){

                    $stanja.forEach(stanje => {
                        if(stanje.raspolozivo > 0){
                            this.$variationPrice.append(
                                '<div class="availability">' +
                                    stanje.naziv + ' (' + stanje.raspolozivo + ')' +
                                '</div>'
                            );
                        } else {
                            this.$variationPrice.append(
                                '<div class="availability availability--backorder">' +
                                    stanje.naziv +
                                '</div>'
                            );
                        }
                    });
                }
            }

            if(variation.hide_price){
                this.$sendInquiryButton.attr("aria-hidden", false);
                $(this.$addToCartButton).attr("aria-hidden", true);

                this.$variationPrice.append(
                    '<div class="variation__price">' +
                        '<div class="variation__price-regular">CIJENA NA UPIT</div>' +
                    '</div>'
                );

                return;
            }

            const regularPrice = parseFloat(variation.display_regular_price);
            const regularPriceText = regularPrice.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            const salePrice = parseFloat(variation.display_price);
            const salePriceText = salePrice.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            const hasValidSale = variation.display_regular_price
                && variation.display_price
                && variation.display_regular_price > variation.display_price;

            if (hasValidSale) {
                const discountPercentage = variation.discount_percentage ?? Math.round(((regularPrice - salePrice) / regularPrice) * 100);

                let discountClass = 'variation__price-sale';
                if (discountPercentage >= 50) {
                    discountClass += ' discount--high';
                } else if (discountPercentage < 25) {
                    discountClass += ' discount--low';
                } else {
                    discountClass += ' discount--medium';
                }

                this.$variationPrice.append(
                    '<div class="variation__price">' +
                        '<div class="' + discountClass +'" data-discount="' + discountPercentage + '">' +
                            salePriceText + ' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                        '</div>' +
                        '<div class="variation__price-regular variation__price-regular--crossed">' +
                            regularPriceText + ' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                        '</div>' +
                    '</div>'
                );

                if(variation.lowest_price_30_days && parseFloat(variation.lowest_price_30_days) > 0){
                    const lowestPrice = parseFloat(variation.lowest_price_30_days).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    this.$variationPrice.append(
                        `<div class="variation__price-lowest-in-30-days">Najniža cijena u posljednjih 30 dana: ${lowestPrice}&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span></div>`
                    );
                }

            } else {
                this.$variationPrice.append(
                    '<div class="variation__price">' +
                        '<div class="variation__price-regular">' +
                            regularPriceText + '<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                        '</div>' +
                    '</div>'
                );
            }

            if(variation.stock_status === 'outofstock'){
                this.$sendInquiryButton.attr("aria-hidden", false);
                $(this.$addToCartButton).attr("aria-hidden", true);
                return;
            }

            this.$sendInquiryButton.attr("aria-hidden", true);
            $(this.$addToCartButton).attr("aria-hidden", false);

            let variationId = variation.variation_id;
            let oblpopak = variation.oblpopak;
            let pakovanje = variation.pakovanje;
            let faktoroblika= parseFloat(variation.faktoroblika);
            let oblik = variation.oblik;

            if(faktoroblika != 1){
                const oblikPrice = (salePrice/faktoroblika).toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                this.$variationPrice.append(
                    '<div class="variation__price-lowest-in-30-days">' +
                        oblik + ' = ' + oblikPrice + '<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                    '</div>'
                );
            }

            let decimalPlaces = W4D_ProductQuantityHelper.getDecimalPlaces(oblpopak);
            let value = W4D_ProductQuantityHelper.roundToDecimalPlaces(oblpopak, decimalPlaces);
            let displayValue = value.toString().replace('.', ',');

            let decimalPlaces2 = W4D_ProductQuantityHelper.getDecimalPlaces(faktoroblika);
            let value2 = W4D_ProductQuantityHelper.roundToDecimalPlaces((oblpopak * faktoroblika), decimalPlaces2);
            let displayValue2 = value2.toString().replace('.', ',');
            if(this.$samoPregled_showPrice)return;
            if (faktoroblika === 1) {
                this.$variationPrice.append(
                    '<div class="product-quantity" data-step="' + oblpopak + '">' +
                        '<i class="product-quantity__stepper product-quantity__stepper--wide icon-minus"></i>' +
                        '<input ' +
                            'type="text" ' +
                            'inputmode="decimal" ' +
                            'name="quantity" ' +
                            'value="' + oblpopak + '" ' +
                            'min="1" ' +
                            'max="9999.99" ' +
                            'step="'+ oblpopak +'" ' +
                            'class="product-quantity__number js-jm2" ' +
                            'data-quantity="' + oblpopak + '" ' +
                            'data-faktor="' + faktoroblika + '" ' +
                            'data-location="variable-product" ' +
                        '>' +
                        '<i class="product-quantity__stepper product-quantity__stepper--wide icon-plus"></i>' +
                        '<span class="product-quantity__unit">' + oblik + '</span>' +
                    '</div>'
                );
            } else {
                this.$variationPrice.append(
                    '<div class="product-quantity__dual" data-variation-id="' + variationId + '">' +
                        '<div class="product-quantity" data-step="' + oblpopak + '">' +
                            '<i class="product-quantity__stepper icon-minus"></i>' +
                            '<input ' +
                                'type="text" ' +
                                'inputmode="decimal" ' +
                                'name="quantity" ' +
                                'value="' + displayValue + '" ' +
                                'min="' + oblpopak + '" ' +
                                'max="9999.99" ' +
                                'step="' + oblpopak +'" ' +
                                'class="product-quantity__number js-jm1" ' +
                                'data-quantity="' + oblpopak + '" ' +
                                'data-faktor="' + faktoroblika + '" ' +
                                'data-location="variable-product" ' +
                            '>' +
                                '<i class="product-quantity__stepper icon-plus"></i>' +
                                '<span class="product-quantity__unit">' + pakovanje + '</span>' +
                        '</div>' +
                        '<span class="text-bold">=</span>' +
                        '<div class="product-quantity" data-step="1">' +
                            '<i class="product-quantity__stepper icon-minus"></i>' +
                            '<input ' +
                                'type="text" ' +
                                'inputmode="decimal" ' +
                                'value="' + displayValue2 + '" ' +
                                'min="1" ' +
                                'max="9999.99" ' +
                                'step="'+ faktoroblika +'" ' +
                                'class="product-quantity__number js-jm2" ' +
                                'data-quantity="' + faktoroblika + '" ' +
                                'data-faktor="' + faktoroblika + '" ' +
                                'data-location="variable-product" ' +
                            '>' +
                                '<i class="product-quantity__stepper icon-plus"></i>' +
                                '<span class="product-quantity__unit">' + oblik + '</span>' +
                        '</div>' +
                    '</div>'
                );
            }
        }

        updateImage(variation) {
            if (!variation?.image_id || variation.image_id <= 0) return;

            const $mainGalleryLinks = $('.js-product-gallery > a');

            const tryActivateThumbnail = (retries = 5) => {
                const $thumb = $(`.product-gallery__thumbnail[data-id="${variation.image_id}"]`);
                const $thumbContainer = $('.product-gallery__thumbnails');

                if ($thumb.length) {
                    $('.product-gallery__thumbnail').removeClass('active');
                    $thumb.addClass('active');

                    if ($thumbContainer.length) {
                        const scrollTop = $thumbContainer.scrollTop();
                        const targetTop = $thumb.position().top + scrollTop - 40;
                        $thumbContainer.animate({ scrollTop: targetTop }, 300);
                    }
                } else if (retries > 0) {
                    setTimeout(() => tryActivateThumbnail(retries - 1), 100);
                }
            };

            tryActivateThumbnail();

            const targetSrc = variation.image?.src?.split('?')[0] ?? '';
            let matchedIndex = -1;

            $mainGalleryLinks.each(function (index) {
                const imgSrc = $(this).find('img').attr('src')?.split('?')[0];
                if (imgSrc === targetSrc) {
                    matchedIndex = index;
                    return false;
                }
            });

            if (matchedIndex !== -1) {
                $mainGalleryLinks.removeClass('active');
                $mainGalleryLinks.eq(matchedIndex).addClass('active');

                const newMainSrc = $mainGalleryLinks.eq(matchedIndex).find('img').attr('src');
                $('.product-gallery__main img').attr('src', newMainSrc);
            }
        }


        updateAttributes(variation) {
            Object.entries(variation.attributes).forEach(([attr_name, attr_value]) => {
                const $row = $(`tr.${attr_name}`);
                const optionSlugs = $row.attr('data-slugs');
                if (optionSlugs) {
                    const options = JSON.parse(optionSlugs);
                    if (options[attr_value]?.trim()) {
                        $row.find('td:nth-child(2) p').text(options[attr_value]);
                    }
                }
            });
        }
    }

    $(document).ready(() => {
        window.W4D_Cart = new W4D_Cart();
    });
})(jQuery);
